import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reduxTypes';
import { AppDispatch } from 'src/store/configureStore';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
